import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	appBarSearch: {
		borderRadius: 4,
		marginBottom: "1rem",
		display: "flex",
		//padding: "16px",
		width: "83%",
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));
